export default "__VITE_ASSET__C9khT2A5__"